import { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import VariantOptionModal from "../components/VariantOptionModal";
import {
  deleteDimensionOption,
  listDimensionOptions,
  listVariantDimensions,
} from "../api/variantDimensions";
import { EmptyState, PageHeader } from "../components/ui";

function SupportVariantOptions() {
  const [dimensions, setDimensions] = useState([]);
  const [dimensionId, setDimensionId] = useState("");
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  function loadDimensions() {
    listVariantDimensions().then((items) => {
      setDimensions(items);
      if (!dimensionId && items.length) setDimensionId(String(items[0].id));
    });
  }

  function loadOptions(did) {
    if (!did) return;
    listDimensionOptions(did).then(setOptions).catch((err) => {
      console.error("OPTIONS LOAD ERROR", err);
      alert("Seçenekler yüklenemedi");
    });
  }

  useEffect(() => {
    loadDimensions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadOptions(dimensionId);
  }, [dimensionId]);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;
    deleteDimensionOption(dimensionId, id).then(() => loadOptions(dimensionId));
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Destek Tabloları / Varyant Seçenekleri"
        subtitle="Seçili anahtar için seçenekleri yönetin."
        actions={
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ width: { xs: "100%", md: "auto" } }}>
            <FormControl sx={{ minWidth: { xs: "100%", sm: 320 } }} size="small">
              <InputLabel id="dimension-select-label">Anahtar</InputLabel>
              <Select
                labelId="dimension-select-label"
                label="Anahtar"
                value={dimensionId}
                onChange={(e) => setDimensionId(e.target.value)}
              >
                {dimensions.map((d) => (
                  <MenuItem key={d.id} value={String(d.id)}>
                    {d.label} ({d.key})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              disabled={!dimensionId}
              onClick={() => {
                setSelected(null);
                setOpen(true);
              }}
            >
              + Yeni Seçenek
            </Button>
          </Stack>
        }
      />

      {!options.length ? (
        <EmptyState
          title="Seçenek bulunamadı"
          description={dimensionId ? "Bu anahtar için henüz seçenek yok." : "Önce bir anahtar seçin."}
          actionLabel={dimensionId ? "+ Yeni Seçenek" : undefined}
          onAction={dimensionId ? () => setOpen(true) : undefined}
        />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Label</TableCell>
                <TableCell>Kod</TableCell>
                <TableCell>Sıra</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {options.map((o) => (
                <TableRow key={o.id} hover>
                  <TableCell>{o.label}</TableCell>
                  <TableCell>{o.code || ""}</TableCell>
                  <TableCell>{o.sort_order}</TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelected(o);
                          setOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(o.id)}>
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {open ? (
        <VariantOptionModal
          dimensionId={dimensionId}
          data={selected}
          onClose={() => setOpen(false)}
          onSaved={() => loadOptions(dimensionId)}
        />
      ) : null}

      {/* Keep spacing consistent on long pages */}
      <Box />
    </Stack>
  );
}

export default SupportVariantOptions;

